const AdvancedAnalyticsBookShow = () => import('@/modules/analytics/views/AdvancedAnalytics/BookShow.vue')
const AdvancedAnalyticsGeneralShow = () => import('@/modules/analytics/views/AdvancedAnalytics/GeneralShow.vue')

export default [
  {
    name: 'advanced-analytics.general.show',
    path: '/advanced-analytics/general',
    component: AdvancedAnalyticsGeneralShow,
    meta: { requiresAuthentication: true }
  },
  {
    name: 'advanced-analytics.books.show',
    path: '/advanced-analytics/books',
    component: AdvancedAnalyticsBookShow,
    meta: { requiresAuthentication: true }
  }
]
